
<template>
  <div id="app">
    <appHead v-if="$route.name != 'login' && $route.name != 'union'"></appHead>
	<KeepAlive>
		<router-view v-wechat-title='$route.meta.title' v-if="$route.meta.keepAlive"></router-view>
	</KeepAlive>
	<router-view v-wechat-title='$route.meta.title' v-if="!$route.meta.keepAlive"></router-view>
    <!-- <appFoot v-if="$route.name != 'login' && $route.name != 'my' && $route.name != 'union'"></appFoot> -->
  </div>
</template>

<script>
import appHead from './components/appHead.vue'
import appFoot from './components/appFoot.vue'

export default {
	name: 'app',
	components: {
		appHead,
		appFoot
	}
}
</script>

<style>
	body{
		margin: 0 !important;
		width: 100vw;
		background: #F7F8FA;
		overflow-x: hidden;
	}
	.flex{
		display: flex;
		flex-wrap: wrap;
	}
	.align{
		display: flex;
		align-items: center;
	}
	.end{
		display: flex;
		align-items: flex-end;
	}
	.center{
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.spb{
		display: flex;
		justify-content: space-between;
	}
	.rows {
	    display: flex;
	    flex-direction: row;
	    align-items: center;
	}
	.between {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	.column {
	    display: flex;
	    flex-direction: column;
	    align-items: center;
	}
	.reverse{
		display: flex;
		flex-direction: row-reverse;
		align-items: center;
	}
	.oneRow{
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}
	.twoRow{
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
	}
	.threeRow{
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 3;
		-webkit-box-orient: vertical;
	}
	.crumbs{
        width: 1232px;
        padding: 19px 0;
        margin: 0 auto;
        font: 14px/14px "Microsoft YaHei";
    }
	.pageBox{
		display: flex;
		flex-direction: row-reverse;
		padding-top: 14px;
	}
	.el-input__inner,.el-textarea__inner {
		border: none !important;
		background: none !important;
		margin: 0 !important;
		padding: 0 !important;
	}
	.el-dialog__body{
		padding-top: 0 !important;
	}
	
	.webLoading{
		width: 100%;
		font: 18px/70px "MicrosoftYaHei";
		color: #666;
		text-align: center;
	}
</style>
